import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import resultIndexByQuestion from "models/ResultIndexByQuestion";

class ResultIndexByQuestion extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts config={resultIndexByQuestion(this.props.data)} />
      </Fragment>
    );
  }
}

ResultIndexByQuestion.propTypes = {
  data: PropTypes.array.isRequired
};

export default ResultIndexByQuestion;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/ResultIndexByQuestion.jsx